/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import DefaultTable from '@/components/tables/DefaultTable'
import CostBreakdownButton from '../CostBreakdownButton'
import { TableContainer } from '@chakra-ui/react'

const TableCostBreakdown = ({
  classButtonCell = '',
  className = '',
  columns = [],
  isHiddenButton = false,
  isInvalid = false,
  labelButton = 'Continue',
  onContinue,
  rowData = {}
}) => {
  return (
    <TableContainer display={{ base: 'none', lg: 'block' }}>
      <DefaultTable className={className}>
        <DefaultTable.Header>
          <tr>
            {columns.map((column, index) => (
              <th key={index}>{column.header}</th>
            ))}
            <th></th>
          </tr>
        </DefaultTable.Header>
        <DefaultTable.Body>
          <tr>
            { columns.map((column, index) => {
              const value = rowData[column.key]
              const classCell = column.className || ''

              return (
                <td key={index} className={classCell}>
                  { column.format ? column.format(value) : value }
                </td>
              )
            })}
            <td className={`flex items-center space-x-2 ${classButtonCell}`}>
              { onContinue && !isHiddenButton && (
                <CostBreakdownButton
                  isInvalid={isInvalid}
                  onContinue={onContinue}
                  labelButton={labelButton}
                />
              )}
            </td>
          </tr>
        </DefaultTable.Body>
      </DefaultTable>
    </TableContainer>
  )
}

export default TableCostBreakdown
